import React from 'react';
import PropTypes from 'prop-types';
import directory from '@tutorbot/directory-api';
import api from '../../utils/api';
import Router from '../../routes';
import Container from '../../components/Home/Container';
import Loading from '../../components/Loading';
import Link from '../../components/Link';
import Course from '../course';
import Button from '../../components/Button';
import { LocalizationContext } from '../../hoc/Localization';
import { SecurityContext } from '../../hoc/Security';
import { EditorContext } from '../../hoc/Editor';
import { UserContext } from '../../hoc/User';
import { shortId } from '../../utils';
import Error from '../_error';
import styles from './styles.less';

const CreateCourse = ({ school, course }) => {
  const { user } = React.useContext(UserContext);
  const { edited, defineContent, setEditMode } = React.useContext(EditorContext);
  const { t, locale } = React.useContext(LocalizationContext);
  const { handleLogin } = React.useContext(SecurityContext);

  const [courseExists, setCourseExists] = React.useState(true);

  React.useEffect(() => {
    if (user && user.schools && !user.schools.length && !user.isAdmin) {
      Router.pushRoute('createSchool', { locale });
    }
  }, [user]);

  React.useEffect(() => {
    (async () => {
      let content = {
        shortId: shortId(),
      };

      defineContent({});

      if (school) {
        await directory()
          .schools.where('shortId', school)
          .first()
          .then(res => {
            if (res) {
              content.school = res;
              content.location = res.location;
            }
          });
      }

      if (course) {
        await api
          .get(`/courses/preview/${course}`)
          .then(res => {
            content = res.course;
          })
          .catch(() => {
            setCourseExists(false);
          });
      }

      defineContent(content);
    })();
  }, [school]);

  React.useEffect(() => {
    setEditMode(true);
  }, []);

  const haveAnySchool = !!user && !!user.schools && !!user.schools.length;

  if (course && !courseExists) {
    return <Error />;
  }

  if (!school) {
    return (
      <Container>
        <div className={styles.titleContainer}>
          <h1>
            {haveAnySchool
              ? t('course.create.schoolChoose.title.haveSchool')
              : t('course.create.schoolChoose.title.noSchool')}
          </h1>
          <span>
            {haveAnySchool
              ? t('course.create.schoolChoose.description.haveSchool')
              : t('course.create.schoolChoose.description.noSchool')}
          </span>
        </div>
        <div className={styles.list}>
          {!!user &&
            user.schools
              .filter(s => !!s)
              .map(s => (
                <Link
                  className={styles.schoolItem}
                  route="createCourse"
                  school={s.shortId}
                  key={s.id}
                >
                  <Button size="default" type="secondary">
                    {s.Name}
                  </Button>
                </Link>
              ))}

          {!user ? (
            <a onClick={() => handleLogin()}>
              <Button version="default" type="primary" className={styles.createButton}>
                {t('school.create')}
              </Button>
            </a>
          ) : (
            <Link route="createSchool">
              <Button size="default" type="primary" className={styles.createButton}>
                {t('school.create')}
              </Button>
            </Link>
          )}
        </div>
      </Container>
    );
  }

  return edited && edited.school ? <Course create /> : <Loading full />;
};

CreateCourse.propTypes = {
  school: PropTypes.string,
  course: PropTypes.string,
};

CreateCourse.defaultProps = {
  school: null,
  course: null,
};

CreateCourse.getInitialProps = async ({ query: { school, course } }) => ({ school, course });

export default CreateCourse;
